// Demande de devis multi-produits REVDECO (2026-10-02). Fichier nommé « selection » : les
// listes anti-pub françaises bloquent les scripts dont le nom contient « devis » (vu 2026-10-02).
// Sélection conservée dans le navigateur (localStorage) : le client ajoute autant de
// produits qu'il veut depuis les fiches (vierges, imprimés, brodés, mélangés), puis
// envoie le tout depuis /pages/devis (formulaire contact Shopify → contact@revdeco.fr
// + Shopify Inbox). Chargé sur tout le site (stylesheets.liquid).
(function () {
  var KEY = 'revdeco-devis';
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } };
  var write = function (list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { }
    renderPill();
    document.dispatchEvent(new CustomEvent('rd-devis-change'));
  };
  var API = {
    list: read,
    count: function () { return read().length; },
    add: function (item) {
      var list = read();
      item.ts = Date.now();
      list.push(item);
      write(list);
      return list.length;
    },
    remove: function (i) { var list = read(); list.splice(i, 1); write(list); },
    update: function (i, patch) { var list = read(); if (!list[i]) return; for (var k in patch) list[i][k] = patch[k]; write(list); },
    clear: function () { write([]); }
  };
  window.RDDevis = API;

  // ---- pastille flottante « Ma demande de devis (n) » (bas gauche : la bulle Chat est à droite) ----
  function renderPill() {
    if (/^\/pages\/devis\/?$/.test(location.pathname)) { var o = document.getElementById('rdDevisPill'); if (o) o.remove(); return; }
    var n = read().length;
    var pill = document.getElementById('rdDevisPill');
    if (!n) { if (pill) pill.remove(); return; }
    if (!pill) {
      pill = document.createElement('a');
      pill.id = 'rdDevisPill';
      pill.href = '/pages/devis';
      pill.className = 'rd-devis-pill';
      document.body.appendChild(pill);
    }
    pill.innerHTML = '<span class="rd-devis-pill__i" aria-hidden="true">✎</span>Ma demande de devis <b>' + n + '</b>';
    pill.setAttribute('aria-label', 'Ma demande de devis : ' + n + ' produit' + (n > 1 ? 's' : ''));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderPill); else renderPill();
  window.addEventListener('storage', function (e) { if (e.key === KEY) renderPill(); });
})();
